import { FC } from 'react';
import { observer } from 'mobx-react';
import { Page } from '@servicetitan/design-system';

export const MainPage: FC = observer(() => (
    <Page className="qa-main-page-test" spacing="relaxed">
        test page
    </Page>
));
